module.exports = __webpack_public_path__ + "static/media/this-event-handler.dae446f3.png";